import registerCatcher from './register-catcher';
import catchError from './catch-error';

export default {
  registerCatcher,
  catchError,
};
